// extracted by mini-css-extract-plugin
export var divider = "_m1-0";
export var labelWrapper = "_m1-2";
export var lineSvg = "_m1-1";